// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`SalesButton test Match con el snapshot 1`] = `<div class="container button"><input type="button"></div>`;
